import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Inject stored bearer token as fallback (cross-domain cookies can be blocked)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rn_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

// Resolves an image path to a full URL.
//   • Full HTTP(S) URLs pass through unchanged — used for seed properties
//     where owner photos are hosted on Unsplash / external CDNs.
//   • Relative paths (e.g. "to-let-rentals/uploads/<uid>/<uuid>.jpg") route
//     through the backend's authenticated file server.
export const IMG = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  return `${API}/files/${path}`;
};
